import React from 'react';

const Heading = () => {
  return (
    <div className='text-center mb-8'>
      <h1 className='text-4xl font-semibold text-brandColor'>Testimonials</h1>
      <p className='text-2xl mt-2'>This is what our client are saying</p>
    </div>
  );
};

export default Heading;
